import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import PrintButton from 'atom-components/buttons/print-button/print-button';
import NavTabs from 'atom-components/nav-tabs-lite';
import MainLayout from 'layouts/main';
import { ClustersPath } from 'pages/clusters/routes';

type Props = {
  children: ReactNode;
};

export default function ClusterPageLayout({ children }: Props): ReactElement {
  return (
    <MainLayout
      title="Clusters"
      size="xxl"
      navigationTabs={
        <NavTabs>
          <NavTabs.Item href={ClustersPath.ClusterInfo}>Info</NavTabs.Item>
          <NavTabs.Item href={ClustersPath.ClusterReports}>Aggregated Reports</NavTabs.Item>
        </NavTabs>
      }
      floatingButtons={<PrintButton />}
    >
      {children}
    </MainLayout>
  );
}
